(function(){
  if (window.__creedTrust) return;
  window.__creedTrust = 1;

  var LANG = (document.documentElement.lang || 'sl').toLowerCase().slice(0, 2);
  var T = {
    sl: {
      pdp: ['Plačilo po povzetju, brez doplačila', 'Dostava v 3 do 5 delovnih dneh', 'Vračilo v 5 dneh brez razloga'],
      cart: 'Plačate lahko tudi po povzetju, ko paket pride do vrat. Nič vnaprej.'
    },
    hr: {
      pdp: ['Plaćanje pouzećem, bez nadoplate', 'Dostava za 3 do 5 radnih dana', 'Povrat u 5 dana bez razloga'],
      cart: 'Možete platiti i pouzećem, kad paket stigne na vrata. Ništa unaprijed.'
    },
    en: {
      pdp: ['Cash on delivery, no extra fee', 'Delivery in 3 to 5 working days', '5-day returns, no questions asked'],
      cart: 'You can also pay cash on delivery when the parcel arrives. Nothing upfront.'
    }
  };
  var L = T[LANG] || T.en;

  var css = '.creed-trust{margin:14px 0 4px;padding:12px 14px;border:1px solid #E6E5E1;border-radius:10px;background:#F7F6F3;font-size:13px;line-height:1.45;color:#0B0B0A}' +
    '.creed-trust li{list-style:none;margin:0;padding:3px 0 3px 22px;position:relative}' +
    '.creed-trust ul{margin:0;padding:0}' +
    '.creed-trust li:before{content:"";position:absolute;left:2px;top:9px;width:10px;height:6px;border-left:2px solid #2E7D32;border-bottom:2px solid #2E7D32;transform:rotate(-45deg)}' +
    '.creed-trust li:first-child{font-weight:600}' +
    '.creed-cod{margin:8px 0 10px;padding:9px 12px;border-radius:8px;background:#F2F1EE;font-size:12.5px;line-height:1.4;color:#0B0B0A;text-align:center}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function pdp(){
    if (!/\/products\//.test(location.pathname)) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('.creed-oto, [id*="creed-oto"], .cart-drawer, cart-drawer, .quick-view, quick-view')) continue;
      if (f.getAttribute('data-creed-trust') === '1') continue;
      var btn = f.querySelector('button[type="submit"], [name="add"]');
      if (!btn) continue;
      f.setAttribute('data-creed-trust', '1');
      var box = document.createElement('div');
      box.className = 'creed-trust';
      box.innerHTML = '<ul>' + L.pdp.map(function(x){ return '<li>' + x + '</li>'; }).join('') + '</ul>';
      f.appendChild(box);
      break;
    }
  }

  function cart(){
    var btns = document.querySelectorAll('button[name="checkout"], a[href*="/checkout"], input[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var parent = b.parentNode;
      if (!parent || parent.querySelector(':scope > .creed-cod')) continue;
      var note = document.createElement('div');
      note.className = 'creed-cod';
      note.textContent = L.cart;
      parent.insertBefore(note, b);
    }
  }

  var t = null;
  function run(){ try { pdp(); cart(); } catch(e){} }
  function schedule(){ if (t) clearTimeout(t); t = setTimeout(run, 200); }

  function boot(){
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
